<template>
	<div class="personal-info">
		<div class="personal-info__item">
			<div class="personal-info__title _md">
				{{ $t('Personal Information') }}
			</div>
			<form class="personal-info__form" @submit.prevent="updatePersonalInfo">
				<BaseInput
					class="personal-info__input"
					v-model="personalInfo.name"
					type="text"
					:label="`${$t('First name')}:`"
				/>
				<BaseInput
					class="personal-info__input"
					v-model="personalInfo.surname"
					type="text"
					:label="`${$t('Last name')}:`"
				/>
				<BaseInput
					class="personal-info__input"
					v-model="personalInfo.email"
					type="email"
					:label="`${$t('Email')}:`"
				/>
				<BaseInput
					class="personal-info__input"
					v-model="personalInfo.phone"
					type="tel"
					:label="`${$t('Phone')}:`"
				/>
				<div v-if="personalInfoError" class="personal-info__error">
					{{ personalInfoError }}
				</div>
				<div v-if="personalInfoSuccess" class="personal-info__success">
					{{ personalInfoSuccess }}
				</div>
				<BaseButton
					class="personal-info__submit _btn-bordered"
					type="submit"
					:disabled="isSubmitting"
				>
					<span v-if="isSubmitting">{{ $t('Changing') }}...</span>
					<span v-else>{{ $t('Save Changes') }}</span>
				</BaseButton>
			</form>
		</div>
		<ChangePassword />
	</div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import ChangePassword from '../tabs/ChangePassword.vue';
export default {
	name: 'PersonalInformation',
	components: {
		ChangePassword,
		BaseInput,
		BaseButton,
	},
	data() {
		return {
			isSubmitting: false,
			personalInfo: {
				name: '',
				surname: '',
				email: '',
				phone: '',
			},
			billingInfo: {
				country: '',
				city: '',
				postCode: '',
				address: '',
			},
			countryOptions: [],
			personalInfoError: null,
			billingInfoError: null,
			personalInfoSuccess: null,
			billingInfoSuccess: null,
		};
	},
	mounted() {
		this.isSubmitting = false;
	},
	methods: {
		updatePersonalInfo() {
			this.isSubmitting = true;
			this.personalInfoError = null;
			this.personalInfoSuccess = null;

			this.$http
				.put('user/profile', {
					...this.personalInfo,
					...this.billingInfo,
				})
				.then((response) => {
					if (response.data?.status === 'OK') {
						this.personalInfoSuccess = 'Successfully updated!';
						this.personalInfoError = '';
						setTimeout(() => {
							this.personalInfoSuccess = '';
						}, 2000);
						this.isSubmitting = false;

						// this.$toast.success("Personal information updated successfully!");
					} else {
						this.personalInfoSuccess = '';
						this.personalInfoError =
							this.$t(response.data.message) ||
							'An unexpected error occurred.';
						setTimeout(() => {
							this.personalInfoError = '';
						}, 2000);
						this.isSubmitting = false;
					}
				})
				.catch((error) => {
					this.personalInfoError =
						this.$t(error.response.data.message) ||
						'Error updating personal information.';

					setTimeout(() => {
						this.personalInfoError = '';
					}, 2000);
					this.isSubmitting = false;
					console.error('Error updating personal information:', error);
				});
		},
		//updateBillingInfo() {
		//	this.isSubmitting = true;
		//	this.billingInfoError = null;
		//	this.billingInfoSuccess = null;

		//	this.$http
		//		.put('user/profile', {
		//			...this.personalInfo,
		//			...this.billingInfo,
		//		})
		//		.then((response) => {
		//			if (response.data?.status === 'OK') {
		//				this.billingInfoError = '';
		//				this.billingInfoSuccess = 'Successfully updated!';
		//				// this.$toast.success("Billing information updated successfully!");
		//				setTimeout(() => {
		//					this.billingInfoSuccess = '';
		//				}, 2000);
		//				this.isSubmitting = false;
		//			} else {
		//				this.billingInfoSuccess = '';
		//				this.billingInfoError =
		//					this.$t(response.data.message) ||
		//					'An unexpected error occurred.';
		//				setTimeout(() => {
		//					this.billingInfoError = '';
		//				}, 2000);
		//				this.isSubmitting = false;
		//			}
		//		})
		//		.catch((error) => {
		//			this.billingInfoSuccess = '';
		//			this.billingInfoError =
		//				this.$t(error.response.data.message) ||
		//				this.$t('Error updating billing information.');
		//			setTimeout(() => {
		//				this.billingInfoError = '';
		//			}, 2000);
		//			this.isSubmitting = false;
		//			console.error('Error updating billing information:', error);
		//		});
		//},
		async fetchCountryOptions() {
			try {
				const response = await this.$http.get(
					'countries'
				);
				this.countryOptions = response.data.payload;
			} catch (error) {
				console.error('Error fetching country options:', error);
			}
		},
		async fetchUserData() {
			try {
				const response = await this.$http.get(
					'user/profile'
				);
				this.personalInfo = {
					name: response.data.name,
					surname: response.data.surname,
					email: response.data.email,
					phone: response.data.phone,
				};
				this.billingInfo = {
					country: response.data.country,
					city: response.data.city,
					postCode: response.data.zip,
					address: response.data.address,
				};
			} catch (error) {
				console.error('Error fetching user data:', error);
			}
		},
	},
	created() {
		this.fetchUserData();
		this.fetchCountryOptions();
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.personal-info {
	display: flex;
	gap: 20px;
	@media (max-width: $md2) {
		gap: 10px;
		flex-wrap: wrap;
		justify-content: center;
	}
	&__item {
		flex: 0 1 calc(50% - 10px);
		background-color: var(--bg-blur-card);
		border-radius: var(--border-radius-primary);
		@media (max-width: $md2) {
			flex: 0 1 calc(50% - 5px);
		}
		@media (max-width: 600px) {
			flex: 1 1 100%;
			max-width: 400px;
		}
	}
	&__title {
		text-transform: uppercase;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__form {
	}
	&__select-label {
	}
	&__select {
		height: 44px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__input {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__success,
	&__error {
		text-align: center;
		margin-bottom: 8px;
	}
	&__error {
		color: var(--error-color);
	}
	&__success {
		color: var(--success-color);
	}
	&__submit {
		width: 100%;
		@include adaptiveValue('margin-top', 40, 15);
	}
}
</style>
